module.exports = __webpack_public_path__ + "static/img/far1.4e1fdd3b.png";